import React, { lazy, Suspense } from 'react';
import { Helmet } from 'react-helmet-async';
import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import Footer from '../components/Footer';

// Heavy below-the-fold components: lazy-loaded to reduce initial JS bundle
// (Lighthouse detected ~166 KiB of unused JS on first load)
const WebAnalyzer = lazy(() => import('../components/WebAnalyzer'));
const CookieAnalyzer = lazy(() => import('../components/CookieAnalyzer'));
const LegalGeneratorCTA = lazy(() => import('../components/LegalGeneratorCTA'));
const OSINTSimulator = lazy(() => import('../components/OSINTSimulator'));
const SaaSTimeConsole = lazy(() => import('../components/SaaSTimeConsole'));
const UrgencySection = lazy(() => import('../components/UrgencySection'));
const FinalCTA = lazy(() => import('../components/FinalCTA'));
const Contact = lazy(() => import('../components/Contact'));

// Lightweight inline fallback: just a spacing div, no spinner needed below fold
const SectionFallback = () => <div style={{ minHeight: '200px' }} aria-hidden="true" />;

export const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Auditoría ENS, NIS2 y RGPD · Auditorialegal</title>
        <meta name="description" content="Auditoría forense de ciberseguridad y cumplimiento normativo para Administraciones Públicas. Metodología Full-Stack Compliance Audit UE 2026." />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "ProfessionalService",
                "@id": "https://www.auditorialegal.es/#service",
                "name": "Auditorialegal",
                "url": "https://www.auditorialegal.es",
                "image": "https://www.auditorialegal.es/logo.png",
                "description": "Auditoría forense de ciberseguridad, cumplimiento legal (RGPD, LSSI) y certificación ENS/NIS2 para administraciones públicas y empresas.",
                "telephone": "+34633115067",
                "email": "info@auditorialegal.es",
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "Puerto del Carmen, Edificio Atalaya Nº17",
                  "addressLocality": "Lanzarote",
                  "postalCode": "35510",
                  "addressCountry": "ES"
                },
                "founder": {
                  "@type": "Person",
                  "name": "Joaquín Burgos Bayo"
                }
              },
              {
                "@type": "Person",
                "@id": "https://www.auditorialegal.es/#person",
                "name": "Joaquín Burgos Bayo",
                "jobTitle": "Auditor Pericial y Experto en Ciberseguridad",
                "worksFor": {
                  "@id": "https://www.auditorialegal.es/#service"
                },
                "url": "https://www.auditorialegal.es/sobre-mi",
                "knowsAbout": [
                  "Ciberseguridad",
                  "Esquema Nacional de Seguridad (ENS)",
                  "RGPD",
                  "Auditoría Forense",
                  "Peritaje Informático Judicial",
                  "NIS2"
                ]
              }
            ]
          })}
        </script>
      </Helmet>
      <Navigation />
      <main>
        <Hero />
        <Suspense fallback={<SectionFallback />}>
          <WebAnalyzer />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <CookieAnalyzer />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <LegalGeneratorCTA />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <UrgencySection />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <OSINTSimulator />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <SaaSTimeConsole />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <FinalCTA />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <Contact />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
